import { render, staticRenderFns } from "./BuddhismAdd.vue?vue&type=template&id=6a33130d&scoped=true"
import script from "./BuddhismAdd.vue?vue&type=script&lang=js"
export * from "./BuddhismAdd.vue?vue&type=script&lang=js"
import style0 from "./BuddhismAdd.vue?vue&type=style&index=0&id=6a33130d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a33130d",
  null
  
)

export default component.exports